import {event} from '../modules/event';

/*
* кнопка еще в фильме и кинотеатре и в гармошке
*
* */

export default class {
	constructor(wrapper) {
        var self = this;
		this.wrapper = wrapper;
        this.btn = this.wrapper.getAttribute('data-More-btn') === null ? this.wrapper.querySelector('[data-More-btn]') : this.wrapper;
        event.add(this.btn, 'click', function(e){
            e.preventDefault();
            self._showMore.call(self);
        });
	}

    _createElements(){
        this.fullDesc = this.wrapper.nextSibling.nodeType == 1 ?  this.wrapper.nextSibling :  this.wrapper.nextSibling.nextSibling;

        var prev = this.wrapper.previousSibling.nodeType == 1 ?  this.wrapper.previousSibling :  this.wrapper.previousSibling.previousSibling;
        if(prev && prev.id == 'movieInfo-secondMenu'){
            this.menu = prev;
        }
    }

    _showMore(){
        if(!this.fullDesc) this._createElements();
        this.wrapper.style.display = 'none';
        this.fullDesc.className = this.fullDesc.className + ' js-active';
        if(this.menu) this.menu.className = this.menu.className + ' js-active';
    }
};

/*export {More};*/



